// extracted by mini-css-extract-plugin
export default {"title":"PageTitle_title__yXlEU","icon":"PageTitle_icon__XYw8v"};